import { reactive, computed, watch, nextTick } from 'vue';
/**
 * State
 * ---
 */
const activeModal = reactive({
    show: false,
    component: null
});
/**
 * Computed properties
 * ---
 */
const isModalShown = computed(() => activeModal.show);
/**
 * Methods
 * ---
 */
function openModal(modal) {
    if (activeModal.component === null || activeModal.component.__file != modal.__file) {
        activeModal.component = modal;
        nextTick(() => activeModal.show = true);
    }
    else {
        activeModal.show = true;
    }
}
function closeModal() {
    activeModal.show = false;
}
/**
 * Watchers
 * ---
 */
watch(() => activeModal.show, (show) => {
    if (show) {
        document.body.classList.add('modal-open');
    }
    else {
        document.body.classList.remove('modal-open');
    }
});
export function useModal() {
    return {
        isModalShown,
        activeModal,
        closeModal,
        openModal,
    };
}
